import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { IEmailRule, IModal } from "Pages/Tools/EmailRules/EmailRules";

interface IProps {
    modal: IModal;
    onSetModal: (modal: IModal) => void;
    selectedRule: IEmailRule;
    onSetSelectedRule: (rule?: IEmailRule) => void;
    editRules: (rule: IEmailRule, action: string) => Promise<void>;
}

export default function DeleteModal({
    modal,
    onSetModal,
    selectedRule,
    onSetSelectedRule,
    editRules,
}: IProps) {
    const toggle = () => {
        onSetModal("");
        onSetSelectedRule();
    };

    return (
        <Modal isOpen={modal === "delete"} toggle={toggle}>
            <ModalHeader>Delete Rule</ModalHeader>
            <ModalBody>
                Are you sure you want to delete <b>{selectedRule.name}</b>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    onClick={() => editRules(selectedRule, "delete")}
                >
                    Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
}
